module.exports = __webpack_public_path__ + "static/media/C3.3c5203bf.webp";